import { OptionModel } from "@generation/schema-core/src/client/model/options/optionModel";
import { translate, watIsUwVraag } from "@opencak-klantondersteuning/shared";

export const watIsUwVraagOptions: OptionModel[] = [
  {
    value: watIsUwVraag.optionBerekeningEigenBijdrage,
    label: translate("BerekeningVanMijnEigenBijdrage")
  },
  {
    value: watIsUwVraag.optionDocumentOfFormulierDigitaalOpsturen,
    label: translate("DocumentOfFormulierDigitaalOpsturen")
  },
  {
    value: watIsUwVraag.optionEigenBijdrageAutomatischBetalen,
    label: translate("EigenBijdrageAutomatischBetalen")
  },
  {
    value: watIsUwVraag.optionOpenstaandSaldoOpvragen,
    label: translate("OpenstaandSaldoOpvragen")
  },
  {
    value: watIsUwVraag.optionIetsAnders,
    label: translate("IetsAnders")
  }
];
